<template>
  <div>
    <Modal
      title="流程审批选择"
      v-model="flowBranchVisible"
      @on-visible-change="visibleChange"
      :transfer="transfer"
    >
      <div v-if="branchType!=='reject'">
        <div style="margin: 10px 0;">请选择审批流程方向：</div>
        <RadioGroup
          type="button"
          v-model="branchValue"
        >
          <Radio
            v-for="branch in branchList"
            :label="branch.NextActivityName"
          ></Radio>
        </RadioGroup>
      </div>
      <div v-if="branchType==='reject'">
        <div style="margin: 10px 0;">请选择退回节点：</div>
        <RadioGroup
          type="button"
          v-model="branchValue"
        >
          <Radio
            v-for="branch in branchList"
            :label="branch.ActivityName"
          ></Radio>
        </RadioGroup>
      </div>
      <div v-if="opinionVisible">
        <div style="margin: 10px 0;">备注：</div>
        <Input v-model="opinion" placeholder="除退回流程必填其余可不填"></Input>
      </div>
      <div slot="footer">
        <Button @click="flowBranchVisible=false">取消</Button>
        <Button
          type="primary"
          @click="branchChoose"
        >确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'flowBranch',
  props: {
    branchList: {
      type: Array,
      default() {
        return []
      }
    },
    visible: {
      type: Boolean,
      default: false
    },
    branchType: {
      type: String,
      default: 'next'
    },
    transfer: {
      type: Boolean,
      default: true
    },
    opinionVisible: {
      type: Boolean,
      default: true
    },
    reason: String,
  },
  data() {
    return {
      flowBranchVisible: false,
      branchValue: '',
      opinion: '',
      lastOpinion: ''
    }
  },
  methods: {
    branchChoose() {
      if (this.branchValue === '') {
        this.$Message.info('请选择流程方向')
        return
      }
      let selectItem
      if (this.branchType !== 'reject') {
        for (let i = 0; i < this.branchList.length; i++) {
          if (this.branchValue === this.branchList[i].NextActivityName) {
            selectItem = this.branchList[i]
            break
          }
        }
      }
      if (this.branchType === 'reject') {
        for (let i = 0; i < this.branchList.length; i++) {
          if (this.branchValue === this.branchList[i].ActivityName) {
            selectItem = this.branchList[i]
            break
          }
        }
      }
      this.$emit('branchChoose', selectItem)
    },
    visibleChange(val) {
      if (val) {
        this.opinion = this.reason
      } else {
        this.lastOpinion = this.opinion
        this.branchValue = ''
        // this.opinion =  ''
        this.$emit('visibleChange', val)
      }
    }
  },
  watch: {
    visible(val) {
      this.flowBranchVisible = val
    }
  }
}
</script>

<style lang="less" scoped>
.ivu-radio-wrapper {
  margin: 6px 2px;
}
</style>
